import { render } from "./MapSelectionColorPicker.vue?vue&type=template&id=6e1720b4"
import script from "./MapSelectionColorPicker.vue?vue&type=script&lang=js"
export * from "./MapSelectionColorPicker.vue?vue&type=script&lang=js"

import "./MapSelectionColorPicker.vue?vue&type=style&index=0&id=6e1720b4&lang=css"
script.render = render

export default script